export const ATTRIBUTE_KEYS_TO_DISPLAY = [
  // availability attributes
  'seasonal',
  'certain_days',
  'unavailable',
  // bar type attributes
  'beach_club',
  'cigar_lounge',
  'cocktail_bar',
  'lobby_bar',
  'lounge_bar',
  'poolside',
  'pub',
  'snack_bar',
  'sports_bar',
  'swim_up_bar',
  'wine_bar',
  // restaurant type attributes
  'a_la_carte',
  'bbq',
  'bistro',
  'brasserie',
  'buffet',
  'casual',
  'diner',
  'fine_dining',
  'grill',
  'international',
  'pizzeria',
  'traditional',
  // live entertainment type attributes
  'cabaret',
  'childrens',
  'comedy',
  'family_friendly',
  'music',
  'streamed_sport_events',
  // swimming pool type attributes
  'adults_only',
  'lanes',
  'leisure',
  'relaxation',
  'saltwater',
  'thermal',
  // parking type attributes
  'accessible',
  'secured_parking',
  'street_parking',
  'valet_parking',
  // opening times
  'twenty_four_hour',
];

export const FACILITIES_RANKINGS: Record<string, number> = {
  parking: 1,
  spa: 2,
  spa_and_wellness_facilities: 2,
  wifi: 3,
  swimming_pool: 4,
  bar: 5,
  restaurant: 6,
  reception: 7,
  fitness_centre: 8,
  pets: 9,
  terrace: 10,
  family_friendly: 11,
  ski: 12,
  room_service: 13,
  beach: 14,
  housekeeping: 15,
};

export const ATTRIBUTES_RANKINGS: Record<string, number> = {
  // 1 is unused for type attributes fallback
  unavailable: 2,
  seasonal: 3,
  certain_days: 4,
};
